import { jsx as _jsx } from "react/jsx-runtime";
import { ListSelectionProvider } from '@clds/compound-components';
import { ChildDataRegistryProvider } from './childData.js';
export const MenuProvider = ({ children, registry, select, focusedId, selectedId, }) => (_jsx(ChildDataRegistryProvider, { value: registry, children: _jsx(ListSelectionProvider, { onClick: select, focusedId: focusedId, selectedId: selectedId, children: children }) }));
